module.exports = __webpack_public_path__ + "img/full2-min.b905711f.png";